<style lang="scss" scoped>
@import '$vars';

@screen mobile {
  .columns {
    @apply mx-0 #{!important};
    width: calc(100% - 1.3em)
  }
  .column {
    @apply w-full block mx-0 px-0 #{!important};
  }
}

label , span  {
  strong {
    display: block;
    text-transform: uppercase;
    margin-bottom: 10px !important
  }
  margin-bottom: 20px
}
.scroll-list {
  overflow-x: auto;
}
button {
  background: transparent;
  border: 0;
  padding: 1em 0;
  cursor: pointer
}
h5 {
  color: #4a4a4a;
  font-family: $base-font-family;
  font-size: 18px;
  font-weight: 600;
}
.model {
  margin-right: 40px;
}
.cid {
  margin-left: -5px;
  margin-top: -0.2rem;
}

.files-list {
  width: 100%;
}

.files {
  @apply px-2;
  flex: 0 0 calc((100% - 1rem) / 4);
  margin: 0 0 1.75rem 0;

  &__digital-signature {
    @apply max-w-full rounded-sm text-white cursor-default block font-semibold text-xs my-0 mx-auto #{!important};
    background: rgb(6, 100, 191);
    padding: 0.125rem 0.3rem;
    width: max-content;
  }
}

.modal-footer {
  span {
    align-items: center;
    display: flex;
    justify-content: center;
    width: max-content;
  }
}

.column > strong {
  text-transform: uppercase;
}

.sicknote__footer {
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.cids-list {
  flex: 0 0 70%;

  strong {
    text-transform: uppercase;
    margin-bottom: 0.5rem;
  }

  &__wrapper {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  &__item {
    align-items: center;
    background: $color-blue;
    border: 1px solid $color-blue;
    border-radius: 4px;
    color: white;
    display: flex;
    flex-direction: row;
    font-size: 0.6rem;
    font-weight: 600;
    justify-content: space-between;
    margin: 0.25rem 0.25rem 0 0;
    padding: 0.1rem 0.2rem;

    span {
      cursor: default;
      margin: 0;
      margin-right: 0.15rem;
    }
  }
}
</style>

<template>
  <main class="component-patients" v-if="loaded">
    <print-template
      v-if="modalActive != null"
      type="sicknote"
      :active.sync="modalActive"
      :formData="formData"
      :patient="patient"
      @cancel="modalActive = null"
    />

    <template v-if="!isHistory">
      <div>
        <h2>Atestados</h2>

        <hr />
      </div>
    </template>

    <form
      @submit.prevent="submit()"
      class="columns"
    >
      <label class="column col-6 model">
        <strong>Modelos</strong>

        <select
          v-model="selectedModel"
          :disabled="!appointmentStarted"
          class="form-select"
          @change="changeModel($event)"
        >
          <option readonly key="_0" :value="null">
            Selecione o modelo
          </option>

          <option
            v-for="item of models"
            :value="item"
            :key="item.id"
          >
            {{ item.name }}
          </option>
        </select>
      </label>

      <label class="column col-4">
        <strong>Data</strong>

        <div class="has-icon-right">
          <input
            disabled
            class="form-input"
            type="text"
            :value="$moment(formData.date, 'YYYY-MM-DD').format('DD/MM/YYYY')"
          />

          <dr-icon
            class="form-icon"
            fill="blue"
            name="dashCalendar"
          />
        </div>
      </label>

      <div class="column col-7">
        <strong>Busca CID</strong>

        <dr-autocomplete
          :ref="'autocomplete'"
          :disabled="!appointmentStarted || isDisplayCid"
          :format="'{$code} - {$name}'"
          :return-format="'object'"
          :fields="['name','code']"
          :store-type="'cid'"
          endpoint="cid"
          placeholder="Busque pelo código CID ou pelo nome da doença"
          @change="addCid($event)"
        />
          <label class="form-checkbox">
            <input
              v-model="isDisplayCid"
              type="checkbox"
              :disabled="selectedModel"
            >
            <i class="form-icon" />  Esconder código CID
          </label>
      </div>

      <div class="column col-4 cid">
        <strong>Dias de afastamento</strong>

        <input
          v-model="daysAway"
          v-mask="'###'"
          :disabled="isImmediateReturn"
          min="1"
          type="number"
          placeholder="Dias de afastamento"
          class="form-input"
        >
        <div class="form-group">
          <label class="form-checkbox">
            <input
              v-model="isImmediateReturn"
              type="checkbox"
            >

            <i class="form-icon" /> Retorno imediato
          </label>
        </div>
      </div>

      <span class="column col-12">
        <strong>Atestado</strong>

        <ckeditor
          v-model="getDescription"
          :editor="editor"
          :config="editorConfig"
          @ready="onReady"
        />
      </span>

      <footer class="sicknote__footer">
        <dr-submit
          :disabled="!appointmentStarted || !isSubmitEnabled"
          :sending="sending"
          text="Salvar"
          class="btn-sm"
        />

        <div
          v-if="cidsArray.length > 0"
          class="cids-list"
        >
          <strong>CIDs escolhidos</strong>

          <ul class="cids-list__wrapper">
            <li
              v-for="(cid, index) in cidsArray"
              :key="`cid-item_${index}`"
              class="cids-list__item"
            >
              <span>
                {{ cid.code }} - {{ cid.name }}
              </span>

              <i
                class="icon icon-cross clickable"
                @click="removeCid(cid)"
              />
            </li>
          </ul>
        </div>
      </footer>
    </form>

    <file-history
      v-if="isActiveAppointment"
      type="sicknote"
      :appointment-id="appointment.id"
      :is-active-appointment="isActiveAppointment"
      :is-medical-history-visible="isMedicalHistoryVisible.status"
      :appointment-date="appointment['appointment_start']"
    />
  </main>
</template>

<script>
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/pt-br'
import CKEditor from '@ckeditor/ckeditor5-vue'
import DocumentEditor from '@ckeditor/ckeditor5-build-decoupled-document/build/ckeditor'
import drSubmit from '@/components/form/submit'
import drAutocomplete from '@/components/form/autocomplete'
import printTemplate from '@/components/templates/print/'
import FileHistory from '@/components/layout/appointments/fileHistory'
import EventBus from '@/globals/eventBus'

export default {
  props: {
    patient: {
      required: false
    },

    appointment: {
      required: false
    },

    appointmentStarted: {
      required: false
    },

    isMedicalHistoryVisible: {
      required: false
    },

    isHistory: {
      default: () => false
    }
  },

  components: {
    ckeditor: CKEditor.component,
    drSubmit,
    drAutocomplete,
    printTemplate,
    FileHistory
  },

  data () {
    return {
      modalActive: null,
      loaded: false,
      notes: [],
      padination: {},
      loadedList: false,
      sending: false,
      send: false,
      editor: DocumentEditor,
      models: [],
      selectedModel: null,
      isDisplayCid: false,
      cidsArray: [],
      isImmediateReturn: false,
      daysAway: 1,
      formData: {
        date: null,
        note: ''
      },
      days: 1,
      formChanged: false,
      editorConfig: {
        language: 'pt-br',
        removePlugins: ['Heading', 'Link'],
        toolbar: ['bold', 'italic', 'strikethrough', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo'],
        highlight: {
          options: [
            {
              model: 'bluePen',
              class: 'pen-blue',
              title: 'Blue pen',
              color: 'rgb(79, 159, 207)',
              type: 'pen'
            }
          ]
        }
      },
      currentDocument: null,
      modalType: null
    }
  },

  computed: {
    defaultText () {
      const text = `Atesto para os devidos fins de direito que o paciente\
      <mark class="pen-blue"><strong>${this.patient.name}</strong></mark>,\
      portador do documento de identidade (RG)\
      <mark class="pen-blue"><strong>${this.patient.rg || '_______________'}</strong></mark>,\
      foi submetido a consulta médica nesta data${this.isImmediateReturn ? ', entre __________ e ___________' : ''}\
      ${!this.isDisplayCid ? this.cidsList : ''}\
      ${this.isImmediateReturn ? ', podendo retornar normalmente para suas atividades.' : '.'}\
      ${!this.isImmediateReturn ? `<br /><br />\
      Em decorrência, deverá permanecer afastado por um período de\
      <span class="daysAway"><strong>${parseInt(this.daysAway)} dia${this.daysAway > 1 ? 's' : ''}</strong></span>, a partir desta data.` : ''}`

      return text
        .replace(/(\s){2,}/gi, ' ')
        .replace(/(\s,)/gi, ',')
        .replace(/(\s?\s\.)/gi, '.')
    },

    cidsList () {
      if (this.cidsArray.length > 0) {
        const cids = this.cidsArray.length === 1
          ? `<strong>${this.cidsArray[0].code}</strong>`
          : this.cidsArray.reduce((prev, next, i) => {
            const name = `<strong>${next.code}</strong>`
            const connector = i === this.cidsArray.length - 1
              ? ' e '
              : i === 0 ? '' : ', '

            return `${prev}${connector}${name}`
          }, '')

        const text = `, sendo portador\
        da${this.cidsArray.length > 1 ? 's' : ''}\
        afecç${this.cidsArray.length > 1 ? 'ões' : 'ão'}\
        <span class="cid">${cids}</span>`

        return text.replace(/(\s){2,}/gi, ' ')
      }

      return '<b><i>[procure os CIDs na caixa de busca acima]</i></b>'
    },

    getDescription: {
      get () {
        return this.formData.note
      },

      set (value) {
        this.formData.note = value
      }
    },

    appointmentSickNotes () {
      const todaySickNotes = []
      const currentAppointment = this.$store.getters.getActiveAppointments

      this.notes.forEach((note) => {
        currentAppointment.forEach((appointment) => {
          if (appointment.id === note.agenda.id) {
            todaySickNotes.push(note)
          }
        })
      })

      return todaySickNotes
    },

    isSubmitEnabled () {
      if (!this.isDisplayCid && this.cidsArray.length === 0) {
        return false
      }

      return true
    },

    isActiveAppointment () {
      if (
        this.$store.getters.getActiveAppointments.length > 0 &&
        this.$store.getters.getActiveAppointments[0].id === this.$attrs['agenda_id']
      ) {
        return true
      }

      return false
    }
  },

  watch: {
    defaultText: {
      deep: false,
      immediate: false,
      handler (text) {
        this.formData.note = text
      }
    },
    'formData.note' (next, prev) {
      if (prev) {
        if (next.length !== prev.length) {
          this.formChanged = true
        }
      }
    }
  },

  created () {
    this.formData.note = this.defaultText

    EventBus.$on('submit-sickNote', (args) => {
      if (this.isSubmitEnabled) {
        this.submit(args)
      } else {
        console.log('entrei aqui')
        this.$store.dispatch('setModalAlert', {
          title: 'Atenção',
          body: 'Este formulário contém dados inválidos e não foi possível salvá-lo.',
          size: 'md',
          active: true
        })
      }
    })
  },

  mounted () {
    this.fetch()
  },

  methods: {
    addCid (cid = null) {
      if (cid && !this.cidsArray.some(t => t.id === cid.id)) {
        this.cidsArray.push(cid)

        this.$store.dispatch('setModalAlert', {
          title: 'Sucesso',
          body: `CID ${cid.code} adicionado com sucesso.`,
          size: 'md',
          active: true
        })

        this.$nextTick(() => {
          this.$refs.autocomplete.resetValues()
        })
      }
    },

    removeCid (cid = null) {
      if (cid) {
        const index = this.cidsArray.findIndex(item => item.id === cid.id)
        this.cidsArray.splice(index, 1)
      }
    },

    immediateReturn () {
      this.formData.days = 0
      this.formData.description = this.immediateReturnText
    },

    changeModel () {
      let description = (this.selectedModel || {}).description || this.defaultText

      if (description) {
        this.days = description.match(/([0-9]*)<strong>.<\/strong>/g)
          ? description.split(/([0-9]*)<strong> <\/strong>/g)[1]
          : 0

        this.getDescription = description
          .toString()
          .replace('#NomeDoPaciente', this.patient.name)
          .replace('#NumeroDoRg', this.patient.rg || '_______________')
          .replace(
            /<strong>(\d\s)dia(s\b|\b)<\/strong>/g,
            `<strong>${
              this.fn_NUMBERS_ONLY(this.days)} dia${this.days > 1 ? 's' : ''
            }</strong>`
          )
      }
    },

    paginationSickNoteList () {
      if (
        !this.loadedList ||
        this.pagination.currentPage >= this.pagination.currentPage.totalPages
      ) {
        return
      }

      const url = `/sick_note?${
        this.$route.params.patientType
      }=${
        this.patient.id
      }&order=sn.date&orientation=DESC&itensPerPage=10&page=${
        this.pagination.currentPage + 1
      }`

      this.loadedList = false
      this.fn_SHOW_PROGRESS()
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.pagination = res.data.pagination
          this.formData.date = this.$moment().format('YYYY-MM-DD')
          this.notes = [...this.notes, ...res.data.data]
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.loadedList = true
        })
    },

    fetch () {
      const url = `/sick_note?filterAnd[${
        this.$route.params.patientType === 'patient' ? 'u' : 'sp'
      }.id]=${
        this.patient.id
      }&order[sn.date]=desc&itensPerPage=all`

      this.fn_SHOW_PROGRESS()
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.pagination = res.data.pagination
          this.formData.date = this.$moment().format('YYYY-MM-DD')
          this.notes = res.data.data
        })
        .catch(err => console.log('err', err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.loadedList = true
          this.loaded = true
        })

      this.$http
        .get('/doctor/sick_note_model', this.$store.getters.getAuthHeader)
        .then((res) => {
          this.models = res.data.data
          this.formChanged = false
          this.fn_HIDE_PROGRESS()
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.loaded = true
        })
    },

    submit ({ showConfirmation = true, nextSection = null, nextTab = null } = {}) {
      this.sending = true
      this.fn_SHOW_PROGRESS()

      if (!this.hasDisplayCidCode) {
        this.hasDisplayCidCode = 0
      }

      const data = {
        agenda: this.appointment.id,
        date: this.formData.date,
        note: String(this.formData.note)
          .replace(/<mark class="pen-blue">/gi, '</strong>')
          .replace(/<\/mark>/gi, '</strong>'),
        hasDisplayCidCode: this.hasDisplayCidCode
      }

      EventBus.$emit('appointment-start-saving')

      this.$http
        .post(`/sick_note`, { sick_note: data }, this.$store.getters.getAuthHeader)
        .then((res) => {
          const msg = !this.isActiveAppointment
            ? `Seu atestado foi gerado com sucesso${
              this.patient.email ? ` e será enviado para o e-mail do paciente (<b>${this.patient.email}</b>).` : '.'
            } Caso você tenha certificado de assinatura digital, levará alguns minutos para que o documento seja assinado digitalmente.`
            : 'Atestado criado com sucesso'

          if (showConfirmation) {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: msg,
              size: 'md',
              active: true
            })
          }
          this.formData.date = null
          this.formData.note = this.defaultText
          this.sent = true
          this.sending = false
          this.fetch()
          this.fn_HIDE_PROGRESS()
          this.formChanged = false

          if (nextSection) EventBus.$emit('consultation-change-section', nextSection)
          if (nextTab) EventBus.$emit('consultation-change-tab', nextTab)
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.isDisplayCid = false
          this.cidsArray = []
          this.isImmediateReturn = false
          this.daysAway = 1
          this.sending = false
          this.fn_HIDE_PROGRESS()

          EventBus.$emit('appointment-stop-saving')
          EventBus.$emit('reload-file-history')
        })
    },

    onReady (editor) {
      this.$nextTick(() => {
        editor.ui.view.editable.element.parentElement
          .insertBefore(
            editor.ui.view.toolbar.element,
            editor.ui.view.editable.element
          )

        editor.plugins.get('TextTransformation').isEnabled = false
      })
    },

    openSickNote (note) {
      if (('signed_file' in note) && note['signed_file']) {
        const url = `${process.env.ROOT_API}/s3/file/sick_note/${note['id']}/signed_file`
        this.$http
          .get(
            url,
            {
              headers: this.$store.getters.getAuthHeader.headers,
              responseType: 'blob'
            }
          )
          .then(res => this.generatePDFFile(res.data))
          .then(objURL => this.embedFile(objURL))
          .then((embed) => {
            if (embed) {
              this.currentDocument = 'Atestado médico'
              this.modalType = 'document'
            }
          })
          .catch(err => console.trace(err))
      } else {
        this.modalActive = note
      }
    },

    generatePDFFile (rawData) {
      const blob = new Blob([rawData], { type: 'application/pdf' })
      return URL.createObjectURL(blob)
    },

    embedFile (file = null) {
      if (file) {
        const wrapper = document.querySelector('#pdf__container')
        const embed = document.createElement('embed')
        embed.classList.add('pdf-file')
        embed.style.height = '70vh'
        embed.style.width = '100%'
        embed.setAttribute('src', file)
        wrapper.appendChild(embed)

        return true
      }

      return false
    },

    removeEmbed () {
      const wrapper = document.querySelector('#pdf__container')
      const embed = wrapper.querySelectorAll('embed')
      for (let el of embed) {
        el.remove()
      }
      this.modalType = null
      this.currentDocument = null
    },

    isToday (sickNote) {
      return this.$moment().isSame(this.$moment(sickNote['date']), 'day')
    },

    removeSickNote (sickNoteId) {
      const removeSickNote = (id) => {
        this.fn_SHOW_PROGRESS()
        this.$http
          .delete(`sick_note/${id}`, this.$store.getters.getAuthHeader)
          .then((res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Atestado médico removido com sucesso.',
              size: 'md',
              active: true
            })
          })
          .catch(err => this.fn_HANDLE_ERROR(err))
          .finally(() => {
            this.fn_HIDE_PROGRESS()
            this.fetch()
          })
      }

      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: 'Tem certeza que deseja apagar o atestado médico? Essa ação não poderá ser desfeita.',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose (v) {
          if (v) {
            removeSickNote(sickNoteId)
          }

          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    },

    hasUnsavedData () {
      return this.formChanged
    }
  }
}
</script>
